import React from "react";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import moment from "moment";
import Badge from "react-bootstrap/Badge";
import returnBadgeVariant from "../../../helperFunctions/componentStyleHelper/componentStyleHelper";
import styles from "./TableComponent.module.css";
import {
  FormOutlined,
  ZoomInOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";

export default function TableComponent(props) {
  const headers = props.headers.map((header) => <th key={header}>{header}</th>);

  const date = moment(new Date()).format("YYYY-DD-MM-hh-mm-ss");

  return (
    <>
      <div className="row justify-content-center data-table">
        <div className="col-lg-11">
          <div className="table-responsive">
            <table
              className="table table-hover table-bordered"
              style={{ border: "0" }}
            >
              <thead>
                <tr style={{ textAlign: "center" }} className="tr_table">
                  {headers}
                </tr>
              </thead>
              <tbody>
                {props.parentState.formListData.map((element, index) => {
                  let imePrezime =
                    element.ime && element.prezime ? (
                      element.ime + " " + element.prezime
                    ) : (
                      <i>Podatak nije unesen.</i>
                    );

                  let konacniNaziv = element.nazivSubjekta
                    ? element.nazivSubjekta
                    : imePrezime;

                  return (
                    <tr key={index}>
                      <td>{element.formDescription}</td>
                      <td>{konacniNaziv}</td>
                      <td>
                        {moment(element.datPodnosenja).format("DD.MM.YYYY")}
                      </td>
                      <td
                        className={styles.center_buttons}
                        className="ant_batn"
                      >
                        <ButtonComponent
                          id={`pregled-${element.zahtjevId}${index}`}
                          variant="secondary"
                          onClick={(e) =>
                            props.openModal(
                              element.zahtjevId,
                              element.zahtjevAtrId,
                              e
                            )
                          }
                          //size="small"
                          size="sm"
                          //  style={{ width: "100px" }}
                        >
                          {/* Pregledaj */}
                          <ZoomInOutlined id={`zoom-outlined${index}`} />
                        </ButtonComponent>
                      </td>

                      <td
                        className={styles.center_buttons}
                        className="ant_batn"
                      >
                        <ButtonComponent
                          // disabled={element.status === 1 || element.status === 4}
                          disabled={
                            element.status !== 2 && element.status !== 9
                          }
                          onClick={(e) =>
                            props.solutionsHandler(
                              e,
                              element.zahtjevId,
                              element.zahtjevAtrId,
                              element.formId,
                              element.status
                            )
                          }
                          id={`kreiraj-${element.zahtjevId}`}
                          value={element.zahtjevId}
                          variant="secondary"
                          //size="small"
                          size="sm"
                          // style={{ width: "100px" }}
                        >
                          <PlusCircleOutlined key={`circle-key${index}`} />
                          {/* Kreiraj */}
                        </ButtonComponent>
                      </td>
                      <td
                        className={styles.center_buttons}
                        className="ant_batn"
                      >
                        <ButtonComponent
                          disabled={element.formId == 2 || element.formId == 9}
                          onClick={props.showDateModal(element.zahtjevAtrId)}
                          id={`date-${element.zahtjevId}`}
                          value={element.zahtjevId}
                          variant="secondary"
                          //size="small"
                          size="sm"
                          //  style={{ width: "100px" }}
                        >
                          {/* Unos */}
                          <EditOutlined key={`edit-outlined${index}`} />
                        </ButtonComponent>
                      </td>
                      <td
                        className={styles.center_buttons}
                        className="ant_batn"
                      >
                        <ButtonComponent
                          disabled={
                            //element.isEnabled === 0 || (micano jer im ne treba uvjet da je proslo 8 dana)
                            element.status !== 8 ||
                            element.formId == 2 ||
                            element.formId == 9 ||
                            element.formId == 11 ||
                            element.formId == 19
                          }
                          onClick={(e) => props.redirectToEntryForm(e, element)}
                          id={element.formId}
                          id={`unos-${element.zahtjevId}`}
                          variant="secondary"
                          //size="small"
                          size="sm"
                          // style={{ width: "100px" }}
                        >
                          {/* Unos */}
                          <FormOutlined key={`from-outlined${index}`} />
                        </ButtonComponent>
                      </td>
                      <td className={styles.center_buttons}>
                        <Badge
                          variant={returnBadgeVariant(element)}
                        >
                          {element.status} - {element.statusStr}
                        </Badge>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
